import React from 'react';

interface MenuItemProps {
  item: { id: string; label: string; path?: string };
  activeItem: string;
  setActiveItem: (id: string) => void;
}

const MenuItem: React.FC<MenuItemProps> = ({ item, activeItem, setActiveItem }) => {
  return (
    <li
      className={`
        px-3 sm:px-5 
        py-3 sm:py-2 
        cursor-pointer 
        transition-colors 
        duration-200
        hover:bg-slate-100 
        dark:hover:bg-zink-700
        rounded-md sm:rounded-none
        mx-2 sm:mx-0
        ${activeItem === item.id ? 'bg-slate-200 dark:bg-zink-600' : 'bg-transparent'}
      `}
      onClick={() => setActiveItem(item.id)}
    >
      <p className="mb-1 text-slate-500 dark:text-zink-200 text-sm sm:text-base">
        {item.label}
      </p>
    </li>
  );
};

export default MenuItem;